import styled from 'styled-components'

const SelectionTextStyled = styled.p``
export default SelectionTextStyled
